import { Action } from '@ngrx/store';
import { PatientWorkflow } from '../patient-workflow/patient-workflow.model';

export enum PatientWorkflowApiActionTypes {
  LoadPatientWorkflowsApi = '[PatientWorkflow API] Load PatientWorkflows',
  LoadPatientWorkflowsSuccessApi = '[PatientWorkflow API] Load PatientWorkflows Success',
  LoadPatientWorkflowsFailureApi = '[PatientWorkflow API] Load PatientWorkflows Failure',
  LoadPatientWorkflowApi = '[PatientWorkflow API] Load PatientWorkflow',
  LoadPatientWorkflowSuccessApi = '[PatientWorkflow API] Load PatientWorkflow Success',
  LoadPatientWorkflowFailureApi = '[PatientWorkflow API] Load PatientWorkflow Failure',
  CreatePatientWorkflowApi = '[PatientWorkflow API] Create PatientWorkflow',
  CreatePatientWorkflowSuccessApi = '[PatientWorkflow API] Create PatientWorkflow Success',
  CreatePatientWorkflowFailureApi = '[PatientWorkflow API] Create PatientWorkflow Failure',
  UpdatePatientWorkflowApi = '[PatientWorkflow API] Update PatientWorkflow',
  UpdatePatientWorkflowSuccessApi = '[PatientWorkflow API] Update PatientWorkflow Success',
  UpdatePatientWorkflowFailureApi = '[PatientWorkflow API] Update PatientWorkflow Failure',
  DeletePatientWorkflowApi = '[PatientWorkflow API] Delete PatientWorkflow',
  DeletePatientWorkflowSuccessApi = '[PatientWorkflow API] Delete PatientWorkflow Success',
  DeletePatientWorkflowFailureApi = '[PatientWorkflow API] Delete PatientWorkflow Failure',
}

export class LoadPatientWorkflowsApi implements Action {
  readonly type = PatientWorkflowApiActionTypes.LoadPatientWorkflowsApi;
  constructor(public payload: { params: any } = { params: {} }) {}
}

export class LoadPatientWorkflowsSuccessApi implements Action {
  readonly type = PatientWorkflowApiActionTypes.LoadPatientWorkflowsSuccessApi;
  constructor(public payload: { patientWorkflows: PatientWorkflow[] }) {}
}

export class LoadPatientWorkflowsFailureApi implements Action {
  readonly type = PatientWorkflowApiActionTypes.LoadPatientWorkflowsFailureApi;
  constructor(public payload: { message: string }) {}
}

export class LoadPatientWorkflowApi implements Action {
  readonly type = PatientWorkflowApiActionTypes.LoadPatientWorkflowApi;
  constructor(public payload: { id: string }) {}
}

export class LoadPatientWorkflowSuccessApi implements Action {
  readonly type = PatientWorkflowApiActionTypes.LoadPatientWorkflowSuccessApi;
  constructor(public payload: { patientWorkflow: PatientWorkflow }) {}
}

export class LoadPatientWorkflowFailureApi implements Action {
  readonly type = PatientWorkflowApiActionTypes.LoadPatientWorkflowFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export class CreatePatientWorkflowApi implements Action {
  readonly type = PatientWorkflowApiActionTypes.CreatePatientWorkflowApi;
  constructor(public payload: { patientWorkflow: PatientWorkflow }) {}
}

export class CreatePatientWorkflowSuccessApi implements Action {
  readonly type = PatientWorkflowApiActionTypes.CreatePatientWorkflowSuccessApi;
  constructor(public payload: { patientWorkflow: PatientWorkflow }) {}
}

export class CreatePatientWorkflowFailureApi implements Action {
  readonly type = PatientWorkflowApiActionTypes.CreatePatientWorkflowFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export class UpdatePatientWorkflowApi implements Action {
  readonly type = PatientWorkflowApiActionTypes.UpdatePatientWorkflowApi;
  constructor(public payload: { patientWorkflow: PatientWorkflow }) {}
}

export class UpdatePatientWorkflowSuccessApi implements Action {
  readonly type = PatientWorkflowApiActionTypes.UpdatePatientWorkflowSuccessApi;
  constructor(public payload: { patientWorkflow: PatientWorkflow }) {}
}

export class UpdatePatientWorkflowFailureApi implements Action {
  readonly type = PatientWorkflowApiActionTypes.UpdatePatientWorkflowFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export class DeletePatientWorkflowApi implements Action {
  readonly type = PatientWorkflowApiActionTypes.DeletePatientWorkflowApi;
  constructor(public payload: { id: string }) {}
}

export class DeletePatientWorkflowSuccessApi implements Action {
  readonly type = PatientWorkflowApiActionTypes.DeletePatientWorkflowSuccessApi;
  constructor(public payload: { id: string }) {}
}

export class DeletePatientWorkflowFailureApi implements Action {
  readonly type = PatientWorkflowApiActionTypes.DeletePatientWorkflowFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export type PatientWorkflowApiActions =
  | LoadPatientWorkflowsApi
  | LoadPatientWorkflowsSuccessApi
  | LoadPatientWorkflowsFailureApi
  | LoadPatientWorkflowApi
  | LoadPatientWorkflowSuccessApi
  | LoadPatientWorkflowFailureApi
  | CreatePatientWorkflowApi
  | CreatePatientWorkflowSuccessApi
  | CreatePatientWorkflowFailureApi
  | UpdatePatientWorkflowApi
  | UpdatePatientWorkflowSuccessApi
  | UpdatePatientWorkflowFailureApi
  | DeletePatientWorkflowApi
  | DeletePatientWorkflowSuccessApi
  | DeletePatientWorkflowFailureApi;
